import { NODE_TYPES } from '@services/conditionGenerator/constants';

function multiConstantGenerator(values) {
  return {
    type: NODE_TYPES.MULTI_CONSTANT,
    values: values.map(String)
  };
}

export default multiConstantGenerator;
